import { styled } from "@mui/material/styles";
import { Stack } from "@mui/material";

export const ParentStack = styled(Stack)({
  flexDirection: "row",
  alignItems: "center",
});
